import PasswordStrengthBar from '@grnhse/seedling/lib/azalea/components/purgatory/password_strength_bar';
import styled from 'styled-components';

const StyledBar = styled.div`
  margin: 0 auto;
  width: 98%;
`;

// @ts-expect-error - TS2686 - 'React' refers to a UMD global, but the current file is a module. Consider adding an import instead.
class Bar extends React.Component {
  render() {
    return (
      // @ts-expect-error - TS2686 - 'React' refers to a UMD global, but the current file is a module. Consider adding an import instead.
      <StyledBar>
        {/* @ts-expect-error - TS2322 - Type '{ children?: ReactNode; }' is not assignable to type 'IntrinsicAttributes & Props'. | TS2686 - 'React' refers to a UMD global, but the current file is a module. Consider adding an import instead. */}
        <PasswordStrengthBar {...this.props} />
      </StyledBar>
    );
  }
}

export default Bar;
